import { MOVE_ACCOUNT_ITEMS } from 'root/src/shared/descriptions/endpoints/endpointIds'
import { otherEndpointType } from 'root/src/shared/descriptions/endpoints/lenses'

export default {
	[MOVE_ACCOUNT_ITEMS]: {
		endpointType: otherEndpointType,
	},
}
